module.exports = __webpack_public_path__ + "static/media/vu.9c4c893a.svg";